import { mapGetters } from "vuex"
import some from 'lodash/some'
//import filter from 'lodash/filter'
import find from 'lodash/find'
import get from 'lodash/get'
import intersection from 'lodash/intersection'

const InstructorAbilities = {

  computed: {
    ...mapGetters({
      //- Map using aliases to avoid name clashes
      iaMixGetProfessionById: 'basic/getProfessionById',
      iaMixSystemSettings: 'basic/systemSettings',
      iaMixCurrentUser: 'currentuser/currentUser',
    })
  },

  methods: {

    /* instructor: object
        {
          apprentices: [<obj>, ...],
          employed: {
            tradeCertificates: [<obj>, ...],
            instructorExemptions: [<obj>, ...],
            machinequalifications: [<obj>, ...]
          }
        }

       professionId: number
       machineQualificationIds: [number, number]
    */
    needToReadInstructor() 
    {
      const tcs = get(this,'iaMixCurrentUser.tradeCertificates',[])
      if (!(tcs.length>0)) {
        return true;
      }
      const item = tcs[0]

      if (item && item.readInstructionsOn) {
        const profession = this.iaMixGetProfessionById(item.professionId);
  
        if (profession && profession.newInstructionsAt) {  
          return Boolean(item.readInstructionsOn < profession.newInstructionsAt);
        }
      }
      return true;
    },

    canHaveAnotherApprentice(instructor, professionId, machineQualificationIds, GU = true) {      

      /* Expects instructor to be (minimum) like
        {
          apprentices: [{education: {basicEducationCertificate: { ... }}}],
          employed: {
            tradeCertificates: [{professionId: 1}], 
            instructorExemptions: [{professionId: 2, status: "unapproved"}], 
            machinequalifications: [{machineId: 4}, {machineId: 5}]
          }
        },
      */
      //console.log(instructor.employed.firstName, "listEmployments::", instructor)      

      const maxApprenticesForInstructorTotal = 3
      const scaffoldingApprenticeInGu = instructor.apprentices.find(a => 
        (a.profession && a.profession.id=='848' && a.education && a.education.basicEducationCertificate===null))
      const anotherScaffoldingApprenticeInGu = Boolean(scaffoldingApprenticeInGu && professionId=='848' && GU)
      //let professionObj = this.iaMixGetProfessionById(professionId)
      
      //- Check num of apprentices to see if we can have another
      const canHaveAnother =
        anotherScaffoldingApprenticeInGu ? false : 
          (
            //- Other professions can have maxApprenticesForInstructor in both GU and Ktid
            Boolean(instructor.apprentices.length < maxApprenticesForInstructorTotal)
          )

      //- Check certificates
      const haveCerts = this.haveCertificates(instructor, professionId, machineQualificationIds, GU)
      //console.log(canHaveAnother, "haveCerts::", haveCerts)
      return Boolean(canHaveAnother && haveCerts)
    },

    haveCertificates(instructor, professionId, machineQualificationIds, GU = true) {

      /* Expects instructor to be (minimum) like
        {
          employed: {
            tradeCertificates: [{professionId: 1}], 
            instructorExemptions: [{professionId: 2, status: "unapproved"}], 
            machinequalifications: [{machineId: 4}, {machineId: 5}]
          }
        },
      */

      const professionObj = this.iaMixGetProfessionById(professionId)
      professionObj.isScaffoldingProfession = Boolean(professionId == '848')
      // NOTICE - Only _really_ checks for cerificates when GU===true and for machine professions
      let hasValidIE = false
      let hasValidTC = false
      let hasValidMachines = false

      //- If it's a machine profession - instructor will need all machines that apprentice wants
      const mqs = get(instructor, 'employed.machinequalifications', [])
      if (professionObj.isMachineProfession && mqs.length > 0 && machineQualificationIds.length > 0) {
        //- Really check for MQs 
        hasValidMachines = Boolean(intersection(mqs.map(mq => mq.machineId), machineQualificationIds).length === machineQualificationIds.length)
      }

      //- Check for Trade certificates
      const tcs = get(instructor, 'employed.tradeCertificates', [])
      if (tcs) {
        hasValidTC = some(tcs, ['professionId', professionObj.id])
      }

      const ies = get(instructor, 'employed.instructorExemptions', [])
      //- Check for Instructor exemption
      if (ies) {
        hasValidIE = some(ies, ie => {
          return Boolean(ie.professionId === professionObj.id && ie.status === "approved")
        })
      }

      //- I case of GU and K-tid and the profession is scaffolding - instructor will need a certificate or an exemption
      if (professionObj.isScaffoldingProfession)
      {
        return Boolean(hasValidTC || hasValidIE)
      }

      //- I case of GU and it's a machine profession - instructor will need a certificate or an exemption
      if (professionObj.isMachineProfession && GU) {
        return Boolean((hasValidTC || hasValidIE) && hasValidMachines)
      }

      //- I case of machine profession OR GU - instructor will need a certificate or an exemption
      if (professionObj.isMachineProfession || GU) {
        return Boolean((hasValidTC || hasValidIE))
      }
      
      //- Else (ie. K-tid and not a machine profession) - anyone can be instructor
      return true
    },

    canApproveEbook(professionId) {      
      //console.log(professionId, "iaMixCurrentUser::", this.iaMixCurrentUser)
      // console.log(professionId)
      // console.log(this.iaMixSystemSettings)      

      // Check exemptions

      var hasValidIE = false
      if (this.iaMixCurrentUser && this.iaMixCurrentUser.instructorExemptions) {
        hasValidIE = some(this.iaMixCurrentUser.instructorExemptions, ['professionId', professionId])
        if (hasValidIE) {
          return {result: true, reason: null}
        }
      }
      //- Check tradecertificates
      var hasValidTC = false
      
      if (this.iaMixCurrentUser && this.iaMixCurrentUser.tradeCertificates) {
        hasValidTC = find(this.iaMixCurrentUser.tradeCertificates, ['professionId', professionId])
      }

      if (hasValidTC) {        

        const lastReadInstructions = this.iaMixCurrentUser.readInstructionsOn
        //If newInstructionsAt is in the future then return true, otherwise the instructor can never approve.
        const newInstructionsAt = (new Date(this.iaMixSystemSettings.newInstructionsAt) > new Date()) ? this.iaMixCurrentUser.readInstructionsOn : this.iaMixSystemSettings.newInstructionsAt
        if (lastReadInstructions) {        
          let shouldReadInstructions = lastReadInstructions >= newInstructionsAt          
          return {result: shouldReadInstructions, reason: null}
        }
        
        return {result: false, reason: 'Har inte läst handledarinstruktionerna'}
      }      
      
      return {result: false, reason: 'Har inget yrkesbevis'}
    }

    //- More methods here?
  }
}

export default InstructorAbilities
